import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  Dropdown,
  Menu,
  notification,
  Drawer,
  Button,
  Space,
  Modal,
} from "antd";
import {
  FaEdit,
  FaEye,
  FaRegEnvelope,
  FaSortAlphaDown,
  FaSortAlphaUp,
  FaArrowsAltV,
  FaCopy,
  FaDownload,
  FaTrash,
  FaSortNumericDown, FaSortNumericUp
} from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Pagination from "@mui/material/Pagination";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import TobNavBar from "../../DashBaord/Top_navbar";
// import VendorListDeletePopUp from "../VendorList/VendorListDeletePopUp";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../UserList/UserList.css";
import { Flex, Spin } from "antd";
import { INVESTOR_LOGIN_URL, FRONT_BASE_URL } from "../../../config/constants";
import * as XLSX from 'xlsx';

import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  LikeOutlined,
  DislikeOutlined,
} from "@ant-design/icons";

import moment from "moment";
import { ASSETS_BASE_URL } from "../../../config/constants";
import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  list,
  chnageStatus,
  deleteData
} from "../../../controllers/investors/investorController";
import { getPage, statusMessage } from "../../../controllers/common";

import { FaPlusSquare, FaUpload } from "react-icons/fa";
import { list as eventsList } from "../../../controllers/events/eventsController";
import {
  sendWelcomeMail,
  sendInvestorInviteMail,
} from "../../../controllers/sendMail/mailcontroller";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [popUpOpen, setPopUpOpen] = useState(false);
  const togglePopUp = () => {
    setPopUpOpen(!popUpOpen);
  };

  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => {
    setFilterShow(!isFilterShow);
  };

  const location = useLocation();
  const restoredListQuery = location.state?.listQuery || {};
  const [value, setValue] = React.useState(restoredListQuery.value || 0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [deleteId, setDeleteId] = useState("");
  const [currentPage, setCurrentPage] = useState(restoredListQuery.currentPage || 1);
  const [emailCompleteStatus, setEmailStatus] = useState(0);
  const [totalinvestorcountread, settotalinvestorcountread] = useState("");
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(restoredListQuery.SKIP || 0);
  const [filter, setFilter] = useState(
    restoredListQuery.filter || {
      from: "",
      to: new Date(),
      filter_by: "",
      search: "",
    }
  ); //End

  const [showRequest, setShowRequest] = useState(restoredListQuery.showRequest || "");
  const [sortByname, setSortByName] = useState(restoredListQuery.sortByname || "");
  const [sortByDate, setSortByDate] = useState(restoredListQuery.sortByDate ?? -1);

  const handleEdit = async (item = {}) => {
    navigate("/investors/addeditdata", {
      state: {
        item,
        listQuery: {
          filter,
          currentPage,
          SKIP,
          sortByname,
          sortByDate,
          showRequest,
          value,
        },
      },
    });
  };

  ////////////// Invite Modal/////////
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [invitationLink, setInvitationLink] = useState("");
  const [inviteeFirm, setInviteeFirm] = useState("");
  const [inviteEmails, setInviteEmails] = useState("");
  const [eventsEmailMode, setEventsEmailMode] = useState("");
  const showInviteModal = (item) => {
    setInvitationLink(FRONT_BASE_URL + "/invitation/" + item?._id);
    setInviteeFirm(item?.investor_firm_name);
    setIsInviteModalOpen(true);
  };

  const handleInviteCancel = () => {
    setInviteEmails("");
    setInvitationLink("");
    setInviteeFirm("");
    setIsInviteModalOpen(false);
  };

  const handleSubmitInviteEmail = () => {
    console.log("eventsEmailMode", eventsEmailMode);
    if (!inviteEmails) {
      notification.open({
        message: "Enter Email/s",
        description: "Please enter emails",
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let rawEmails = inviteEmails.split(",").map((email) => email.trim());
      for (let email of rawEmails) {
        if (!emailRegex.test(email)) {
          notification.open({
            message: "Invalid Email",
            description: `${email} is invalid email!`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
          return false;
        }
      }
      console.log("hererrere");
      sendInviteEmailsSequentially(rawEmails);
    }
  };
  /////// Invite Modal/////////////////

  /*********************************************************
   *  This function is use to fetch investors list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(showRequest ? { status: showRequest } : null),
        },
        ...(filter ? { filter: filter } : null),
        select: {},
        sort: {
          // status: 1,
          ...(sortByname
            ? { investor_firm_name: sortByname === "Y" ? 1 : -1 }
            : { _id: sortByDate ===  "Y" ? 1 : -1 }),
        },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
        } else {
          setListData([]);
        }
        const countOptions = {
          type: "count",
          condition: {
            ...(showRequest ? { status: showRequest } : null),
          },
          ...(filter ? { filter: filter } : null),
        };
        const count = await list(countOptions);
        settotalinvestorcountread(count?.result);
        setTotalPages(getPage(count?.result));
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is use to fetch investors list
   *********************************************************/
  const getEventList = async () => {
    try {
      setIsLoading(true);
      setEventsEmailMode("");
      const options = {
        type: "single",
        condition: { status: "A" },
      };
      const eventListData = await eventsList(options);
      console.log("eventListData", eventListData);
      console.log(
        "eventListData event mode",
        eventListData?.result?.event_email_mode
      );
      if (eventListData.status === true) {
        setEventsEmailMode(eventListData?.result?.event_email_mode);
      } else {
        setEventsEmailMode("");
      }
    } catch (error) {
      console.log("error", error);
    }
  }; //End

  // Handle name sorting
  const handleNameSort = () => {
    setSortByName((prevSort) => (prevSort === "Y" ? "N" : "Y"));
  };

  // Handle date sorting
  const handleDateSort = () => {
    setSortByName("");
    setSortByDate((prevSort) => (prevSort === "Y" ? "N" : "Y"));
  };

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is for sending welcome mail to investors
   *********************************************************/
  const handleSendWelMail = async (params = "") => {
    try {
      setListData([]);

      const options = {
        mailtype: "registration",
        email: params?.investor_email,
        name: params?.investor_first_name + " " + params?.investor_last_name,
        account: params?.investor_email,
        accounttype: "Investor",
        loginurl: INVESTOR_LOGIN_URL,
      };

      const res = await sendWelcomeMail(options);
      if (res.request.status === 200) {
        notification.open({
          message: "Mail sent.",
          description: `Mail sent successfully.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
      } else {
        notification.open({
          message: "Opps!",
          description: `${res?.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      notification.open({
        message: "Opps!",
        description: `Operation not perform yet! please try in some time.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
    getList();
  };

  /*********************************************************
   *  This function is use to change investor status
   *********************************************************/
  const handleStatusChnage = async (status = "", id) => {
    try {
      setListData([]);
      const options = {
        url: `accounts/investors/changestatus`,
        postData: {
          user_id: id,
          status: status,
        },
      };
      const res = await chnageStatus(options);
      if (res.status === true) {
        notification.open({
          message: "Data updated.",
          description: `Data updated successfully.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
      } else {
        notification.open({
          message: "Opps!",
          description: `${res?.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      notification.open({
        message: "Opps!",
        description: `Operation not performed yet! please try in some time.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
    getList();
  };

  //////////////Delete Modal/////////
    const [isDelModalOpen, setIsDelModalOpen] = useState(false);
    const [deltId, setdeltId] = useState("");
    const showDelModal = (id) => {
      setdeltId(id);
      setIsDelModalOpen(true);
    };
    const handleDelCancel = () => {
      setdeltId("");
      setIsDelModalOpen(false);
    };

    const handleDelItem = async() => {
      console.log('deltId->',deltId);
      try {
        const options = {
          url: `accounts/investors/delete`,
          postData: {
            id: deltId
          },
        };
        const res = await deleteData(options);
        if (res.status === true) {
          handleDelCancel();
          notification.open({
            message: "Data updated.",
            description: `Data Deleted successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          handleDelCancel();
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } catch (error) {
        handleDelCancel();
        notification.open({
          message: "Opps!",
          description: `Operation not performed yet! please try in some time.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
      getList();
    }
  ///////Delete Modal/////////////////

  // const handleInviteMail = async () => {
  //   try {
  //     const listData = await list();
  //     if (listData?.result.length > 0) {
  //       sendInviteEmailsSequentially(listData?.result);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     notification.open({
  //       message: "Opps!",
  //       description: `Operation not performed yet! please try in some time.`,
  //       placement: "topRight",
  //       icon: <InfoCircleOutlined style={{ color: "red" }} />,
  //       duration: 2,
  //     });
  //   }
  //   getList();
  // };

  const sendInviteEmailsSequentially = async (allInvestorData) => {
    const totalEmails = allInvestorData.length; // Total number of emails to send
    let completedEmails = 0; // Counter for the number of completed emails

    for (const item of allInvestorData) {
      console.log("item", item);
      const options = new URLSearchParams({
          firmname: inviteeFirm || "",
          invitelink: invitationLink || "",
          inviteemail: item || "",
          mode: eventsEmailMode || "test",
      }).toString();

      console.log("options", options);

      try {
        await sendInvestorInviteMail(options); // Wait for the email to be sent
        completedEmails++; // Increment the counter after a successful email is sent

        // Calculate and log the completion percentage
        const completionPercentage = Math.floor(
          (completedEmails / totalEmails) * 100
        );
        setEmailStatus(completionPercentage);
      } catch (error) {
        console.log("Error sending email:", error);
      }
    }

    // console.log("All emails have been processed.");
    handleInviteCancel();
    notification.open({
      message: "Mail sent.",
      description: `Mail sent successfully.`,
      placement: "topRight",
      icon: <CheckCircleOutlined style={{ color: "green" }} />,
      duration: 2,
    });
  };

  //// export excel
    const handleExportList = async () => {
      // setIsExportLoading(true);
      // setExportLoadingText('Loading Data....');
      try {
          const exportOptions = {
            type: "",
            condition: {}
          };
          // console.log('endDate', endDate);
          // console.log('endDate',endDate);
          const exportDatas = await list(exportOptions);
          // console.log('API res time bat', exportDatas);
          if (exportDatas.status === true) {
            if (exportDatas?.result.length > 0) {
              prepareSheetData(exportDatas?.result);
            } else {
              alert('No data found');
            }
          } else {
            // setIsExportLoading(false);
            console.log('api error');
          }
      } catch (error) {
        // setIsExportLoading(false);
        console.log("error", error);
      } finally {
        // setIsExportLoading(false);
      }
    }
    const prepareSheetData = (data) => {
      console.log('dataCount -', data.length);
      // setExportLoadingText('Preparing Your Data....');
      const mySheet = data.map((items) => {
  
        return {
          "Investing Firm": items?.investor_firm_name || '',
          "Descriptions": items?.investor_description || ''
        }
      });
      // setDataSheet(mySheet);
      downloadExcel(mySheet);
      // setIsExportLoading(false);
    }
  
    const downloadExcel = (dataSheet = []) => {
      // Create a new workbook
      const workbook = XLSX.utils.book_new();
  
      // Convert data for each sheet
      const worksheet = XLSX.utils.json_to_sheet(dataSheet);
  
      // Append sheets to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Firms");
  
      // Trigger download
      XLSX.writeFile(workbook, "InvestingFirms.xlsx");
    };
    //// export excel

  const dropdownMenu = (items) => {
    return (
      <>
        <Menu>
          <Menu.Item key="0" onClick={() => handleEdit(items)}>
            <FaEdit />
            <span className="show_span_edit">Edit</span>
          </Menu.Item>
          {/* <Menu.Item key="1" onClick={() => handleViewAllStore(items)}>
            <FaEye />
            <span className="show_span_edit">All Store</span>
          </Menu.Item> */}
          {items?.status === "I" && (
            <Menu.Item
              key={`02`}
              onClick={() => {
                handleStatusChnage("A", items._id);
              }}
            >
              <LikeOutlined /> <span className="show_span">Active</span>
            </Menu.Item>
          )}
          {items?.status === "A" && (
            <Menu.Item
              key={`02`}
              onClick={() => {
                handleStatusChnage("I", items._id);
              }}
            >
              <DislikeOutlined /> <span className="show_span">Inactive</span>
            </Menu.Item>
          )}
          <Menu.Item
            key={`03`}
            onClick={() => {
              showInviteModal(items);
            }}
          >
            <FaRegEnvelope />{" "}
            <span className="show_span">Send Invitation Link</span>
          </Menu.Item>
          <Menu.Item
            key={`04`}
            onClick={() => {
              showDelModal(items?._id)
            }}
          >
            <FaTrash />{" "}
            <span className="show_span">Delete</span>
          </Menu.Item>
        </Menu>
      </>
    );
  };

  /*********************************************************
   *  This function is ued for handle filter input chnage
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter("");
      setSkip(0);
      setCurrentPage(1);
      inputRef1.current.value = "";
      inputRef2.current.value = "";
      inputRef3.current.value = "";
      inputRef4.current.value = "";
    } catch (error) {}
  };

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre) => ({
        ...pre,
        filter_by: form.get("filter_by") || "",
        search: form.get("search") || "",
        to: form.get("to_date") || "",
        from: form.get("from_date") || "",
      }));
      // console.log('filter',filter);
      // alert('submit');
      handleFiterDrawer();
      setSkip(0);
      setCurrentPage(1);
    } catch (error) {}
  };

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        // Optional: show success toast/message
        notification.open({
          message: "Invitation Link Copied!",
          // description: `Mail sent successfully.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    getEventList();
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
    document.title = "Chiratae Super Admin || Investing Firm List";
  }, [currentPage, showRequest, filter, sortByname, sortByDate]);

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Investing Firm List"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setShowRequest("");
                        setSkip(0);
                        setCurrentPage(1);

                      }}
                    />
                    <Tab
                      label="Active"
                      className="tabs_main_contnet"
                      {...a11yProps(1)}
                      onClick={() => {
                        setShowRequest("A");
                        setSkip(0);
                        setCurrentPage(1);
                      }}
                    />
                    <Tab
                      label="Inactive"
                      className="tabs_main_contnet"
                      {...a11yProps(2)}
                      onClick={() => {
                        setShowRequest("I");
                        setSkip(0);
                        setCurrentPage(1);
                      }}
                    />
                  </Tabs>
                </div>
                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div
                    className="inventory_filter_div"
                    onClick={handleFiterDrawer}
                  >
                    <img
                      src={ASSETS_BASE_URL + "/images/Filter.svg"}
                      alt="filter"
                      className="user_iconses"
                    />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filters
                    </Link>
                  </div>
                  <div onClick={() => handleEdit()}>
                    <button type="button" class="btn btn-dark">
                      <FaPlusSquare className="Promotions_faPlus_Squares" />
                      <span className="request_new_categories">Add New</span>
                    </button>
                  </div>
                  <div
                    onClick={() => {
                      handleExportList();
                    }}
                  >
                    <button type="button" class="btn btn-info">
                      <FaDownload className="Promotions_faPlus_Squares" />
                      <span className="request_new_categories">
                        Export Data
                      </span>
                    </button>
                  </div>
                  {/* <div
                    onClick={() => {
                      navigate("/investors/bulk-upload");
                    }}
                  >
                    <button type="button" class="btn btn-success">
                      <FaUpload className="Promotions_faPlus_Squares" />
                      <span className="request_new_categories">Import</span>
                    </button>
                  </div> */}
                  {/* <div
                    onClick={() => {
                      handleBulkMail();
                    }}
                  > */}
                  {/* <button type="button" class="btn btn-danger">
                      <FaRegEnvelope className="Promotions_faPlus_Squares" />
                      <span className="request_new_categories">
                        Send Welcome mail to all
                      </span>
                    </button> */}
                  {/* </div> */}
                </div>
              </div>
            </Box>
            {/* First Inventory */}
            {/* <InvestorList> */}
            <div>
              <div id="content-wrapper" className="d-flex flex-column">
                <div className="card shadow mb-4">
                  {/* <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold common_inventory_heading">
                        All Vendor's List
                      </h6>
                    </div> */}
                  <div className="card-body pt-0">
                    <div className="table-responsive">
                      <table
                        className="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <thead>
                          {totalinvestorcountread ? (
                            <tr>
                              <th
                                style={{
                                  color: "red",
                                  fontSize: "18px",
                                  fontWeight: "600",
                                }}
                                colSpan={2}
                              >{`Total - ${totalinvestorcountread}`}</th>
                            </tr>
                          ) : null}
                          <tr>
                            <th style={{ width: "8%" }}>Sr no.</th>
                            <th>Image</th>
                            <th>
                              Firm Name{" "}
                              {sortByname === "Y" ? (
                                <FaSortAlphaDown
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleNameSort()}
                                />
                              ) : (
                                <FaSortAlphaUp
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleNameSort()}
                                />
                              )}
                            </th>
                            <th>SPOC Details</th>
                            <th>
                              Created On{" "}
                              {/* <FaArrowsAltV
                                onClick={() => handleDateSort()}
                                style={{
                                  marginLeft: "10px",
                                  cursor: "pointer",
                                }}
                              /> */}
                              {sortByDate === "Y"? (<FaSortNumericDown style={{marginLeft:"10px", cursor:"pointer"}} onClick={()=> handleDateSort()}/>):(<FaSortNumericUp style={{marginLeft:"10px", cursor:"pointer"}} onClick={()=> handleDateSort()}/>)}
                            </th>
                            <th>Invitation Link</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ALLLISTDATA?.length > 0 ? (
                            ALLLISTDATA.map((items, index) => (
                              <>
                                <tr key={index}>
                                  <td>{(currentPage - 1) * 10 + index + 1}</td>
                                  <td>
                                    <div>
                                      {items?.investor_image ? (
                                        <img
                                          src={`${items.investor_image}`}
                                          alt={items?.investor_image}
                                          width="50px"
                                        />
                                      ) : (
                                        <img
                                          src={`../images/IntentoryTableLogo.png`}
                                          alt={`profile-pic`}
                                          width="30px"
                                        />
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="admin_user_list_table">
                                      <div className="admin_user_list_name_gmail">
                                        <span className="admin_user_list_name">
                                          {items?.investor_firm_name}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="admin_user_list_table">
                                      <div className="admin_user_list_name_gmail">
                                        <span className="admin_user_list_name">
                                          {items?.rel_manager?.name} <br/>
                                          {items?.rel_manager?.email}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="admin_user_list_date">
                                    {moment(`${items?.createdAt}`).format(
                                      "DD/MM/YYYY, h:mm A"
                                    )}{" "}
                                  </td>
                                  <td>
                                    <FaCopy
                                      style={{ cursor: "pointer" }}
                                      title="Copy Invitation Link"
                                      onClick={() =>
                                        handleCopy(
                                          FRONT_BASE_URL +
                                            "/invitation/" +
                                            items?._id
                                        )
                                      }
                                    />
                                  </td>
                                  <td
                                    className="admin_user_list_date"
                                    dangerouslySetInnerHTML={{
                                      __html: statusMessage(items.status),
                                    }}
                                  ></td>
                                  <td>
                                    <Dropdown
                                      overlay={() => dropdownMenu(items)}
                                      placement="bottomLeft"
                                      arrow
                                    >
                                      <HiOutlineDotsHorizontal
                                        style={{ cursor: "pointer" }}
                                      />
                                    </Dropdown>
                                  </td>
                                </tr>
                              </>
                            ))
                          ) : isLoading ? (
                            <SkeltonList row={10} col={10} />
                          ) : (
                            <tr>
                              <td colspan="5" className="img-center">
                                <p>No data to show</p>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="table_pagination_sales_order">
                        <Pagination
                          count={TOTALPAGES}
                          onChange={handlePageChange}
                          page={currentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* </InvestorList> */}
          </Box>
        </div>
        <Flex align="center" gap="middle">
          <Spin
            size="large"
            spinning={
              emailCompleteStatus > 0 && emailCompleteStatus < 100
                ? true
                : false
            }
            fullscreen={true}
            tip={`${emailCompleteStatus} % completed`}
          >
            {" "}
          </Spin>
        </Flex>
        {/* <VendorListDeletePopUp
          popUpOpen={popUpOpen}
          togglePopUp={togglePopUp}
          deleteId={deleteId}
          setDeleteId={setDeleteId}
        /> */}
      </div>
      {/* Filter */}
      <Drawer
        title="Investing Firms Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id="filter_form" onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="investor_first_name"
                  className="all_section_for_label_main_class"
                >
                  Search Field :
                </label>
                <select
                  name="filter_by"
                  className="form-control store_input_field"
                  id="filter_by"
                  ref={inputRef1}
                >
                  <option value="">Select search field</option>
                  {/* <option
                    value="investor_first_name"
                    selected={
                      filter?.filter_by === "investor_first_name" ? true : false
                    }
                  >
                    First Name
                  </option>
                  <option
                    value="investor_last_name"
                    selected={
                      filter?.filter_by === "investor_last_name" ? true : false
                    }
                  >
                    Last name
                  </option> */}
                  <option
                    value="investor_firm_name"
                    selected={
                      filter?.filter_by === "investor_firm_name" ? true : false
                    }
                  >
                    Firm name
                  </option>
                  {/* <option
                    value="investor_email"
                    selected={
                      filter?.filter_by === "investor_email" ? true : false
                    }
                  >
                    Email
                  </option>
                  <option
                    value="investor_phone"
                    selected={
                      filter?.filter_by === "investor_phone" ? true : false
                    }
                  >
                    Phone
                  </option> */}
                  <option
                    value="status"
                    selected={filter?.filter_by === "status" ? true : false}
                  >
                    Status
                  </option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="investor_first_name"
                  className="all_section_for_label_main_class"
                >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"
                  ref={inputRef2}
                  defaultValue={filter?.search || ""}
                  // onChange={handleFilterChnage}
                  // value={filter?.search}
                />
              </div>
              {/* <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="investor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="from_date"
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}         
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="investor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="to_date"
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}          
                />
              </div> */}
              <br />
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
      <Modal
        open={isInviteModalOpen}
        onCancel={handleInviteCancel}
        footer={[
          <Button key="close" type="primary" onClick={handleSubmitInviteEmail}>
            Send
          </Button>,
        ]}
      >
        <h5>Send Invite Link on Email</h5>
        {/* <p>{invitationLink}</p> */}
        <input
          type="email"
          placeholder="Enter email"
          value={inviteEmails}
          onChange={(e) => {
            setInviteEmails(e.target.value);
          }}
          className="form-control mt-3"
        />
        <span style={{ color: "#d00d0d" }}>
          To send invite to multiple emails, just separate them with commas( , )
        </span>
      </Modal>
      <Modal open={isDelModalOpen} onCancel={handleDelCancel} 
        footer={[
                <Button key="close"  onClick={handleDelCancel}>
                  Close
                </Button>,
                <Button key="ok" type="primary" onClick={handleDelItem}>
                  Yes, Delete
                </Button>
               ]}>
        <InfoCircleOutlined style={{color: "red",fontSize:"45px"}} />
        <h6 >Please Confirm, do you want to delete ?</h6>
        <p>This will also delete the interests and meetings of this firm.</p>
      </Modal>
    </>
  );
}
